Ext.define('SA.view.TableColRegion', {
    constructor({colId, left, right}) {
        this.colId = colId;
        this.left = left;
        this.right = right;
    },

    getColId() {
        return this.colId;
    },

    getLeft() {
        return this.left;
    },

    getRight() {
        return this.right;
    },

    intersectsRegion(region) {
        return this.getRight() >= region.getLeft() && this.getLeft() <= region.getRight();
    }
});